<template>
  <v-card
    class="pa-4"
    flat
  >
    <h1>{{ enterprise ? enterprise.Name : '' }}</h1>
    <br>
    <v-toolbar :color="enterpriseColor" dark>
      <v-app-bar-nav-icon></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t('enterprises.enterpriseTitle') }}</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <form-enterprise
      :data="enterprise"
      :onDelete="handleDelete"
      :onSave="handleSave"
      :onCancel="handleCancel"
      :onClearStats="handleClearStats"
    />
  </v-card>
</template>

<script>
  import api from '@/services/api'
  import FormEnterprise from './FormEnterprise'
  export default {
    components: {
      FormEnterprise
    },
    data: () => ({
      enterprise: {},
    }),
    computed: {
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      playerID () {
        return this.$route.params.id
      },
    },
    watch:{
      $route (to, from){
        if (to.params.id && to.params.id !== from.params.id) {
          if (to.params.id.length > 0) {
            this.handleGetPlayer()
          }
        }
      }
    },
    mounted () {
      this.handleGetPlayer()
    },
    methods: {
      handleGetPlayer () {
        if (this.playerID !== 'new') {
          api.getItem('players', true, this.playerID).then(response => {
            this.enterprise = {
              Name: response.Name,
              Delay: response.Delay
            }
          })
        } else {
          this.enterprise = null
        }
      },
      handleClearStats () {
        api.deleteItem('stats', this.playerID).then(response => {
          if (response.status === 200) this.$router.push('/players')
        })
      },
      handleDelete () {
        api.deleteItem('players', this.playerID).then(response => {
          if (response.status === 200) this.$router.push('/players')
        })
      },
      handleCancel () {
        this.$router.push('/players')
      },
      handleSave (body) {
        if (this.playerID === 'new') {
          body.EnterpriseID = this.enterpriseID
          api.addItem('players', true, body)
            // .then(response => {
            //   console.log(response)
            // })
            // .catch(error => {
            //   console.log('error', error)
            // })
        } else {
          api.updateItem('players', this.playerID, body)
            // .then(response => {
            //   console.log(response)
            // })
            // .catch(error => {
            //   console.log('error', error)
            // })
        }
        this.$router.push('/players')
      }
    }
  }
</script>
